import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { SanitizerService } from '../../../../../services/sanitizer.service';

@Component({
  selector: 'now-wbsuche-lib-veranstaltungsort',
  templateUrl: './veranstaltungsort.component.html',
  standalone: true,
  imports: [NgOptimizedImage, NgTemplateOutlet]
})
export class VeranstaltungsortComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  @Input()
  public collapsed?: boolean;

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }
}
